import * as React from 'react'
import { Link } from 'react-router'
import EmptyImage from '../../../components/images/EmptyImage'
import { usePermissions } from '../../../hooks/usePermissions'
import { UprightStyle } from '../../../types'

interface ProductWithThumbnailLinkProps {
  productId: number
  thumbnailURL: string
  onClickProduct?: (id: number) => void
  style?: React.CSSProperties
}

const styles: UprightStyle = {
  nonClickableImageThumb: { width: '100%', height: '100%', borderRadius: 2 },
  clickableImageThumb: { width: '100%', height: '100%', borderRadius: 2, cursor: 'pointer' }
}

const ProductWithThumbnailLink: React.FC<ProductWithThumbnailLinkProps> = ({
  productId,
  thumbnailURL,
  style = { padding: 5, width: 65, height: 65, paddingRight: 0 },
  onClickProduct
}) => {
  const { permissions } = usePermissions()
  if (!productId) {
    return (
      <div style={style}>
        <EmptyImage size={50} />
      </div>
    )
  }

  if (onClickProduct) {
    return (
      <div style={style} onClick={() => onClickProduct(productId)}>
        <img src={thumbnailURL} alt="" style={styles.clickableImageThumb} />
      </div>
    )
  }

  if (!permissions.includes('products.view')) {
    return (
      <div style={style}>
        <img src={thumbnailURL} alt="" style={styles.nonClickableImageThumb} />
      </div>
    )
  }

  return (
    <Link to={`/products/${productId}`}>
      <div style={style}>
        <img src={thumbnailURL} alt="" style={styles.clickableImageThumb} />
      </div>
    </Link>
  )
}

export default ProductWithThumbnailLink
